module.exports = __webpack_public_path__ + "static/media/smile-wink.55849571.svg";